// 地址获取

import storage from '@/utils/storage'
export default {
    computed: {
        // 是否存在
        isHasAddress() {
            return !!storage.get('address')
        },
        // 格式化
        addressObj() {
            if (this.isHasAddress) {
                return JSON.parse(storage.get('address'))
            }
        },
        // 获取省市区
        getAddress() {
            if (this.isHasAddress) {
                const address = this.addressObj
                return `${address.addressComponent.province}${address.addressComponent.city}${address.addressComponent.district}`
            }
        },
        // 获取省
        getProvince() {
            if (this.isHasAddress) {
                return this.addressObj.addressComponent.province
            }
        },
        // 获取市
        getCity() {
            if (this.isHasAddress) {
                return this.addressObj.addressComponent.city
            }
        },
        // 获取区
        getDistrict() {
            if (this.isHasAddress) {
                return this.addressObj.addressComponent.district
            }
        }
    }
}
